if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initTextTutorials)
} else {
    initTextTutorials()
}

function initTextTutorials() {
    setTimeout(() => {
        const article = document.querySelector("#app .text-tutorial-wrapper .text-tutorial-inner article")
        if (article) {
            const headings = article.querySelectorAll("h1, h2")
            headings.forEach((el) => {
                el.outerHTML = el.outerHTML.replace(/h[12]/g, "h3")
            })
        }

        let tools = document.querySelector(".tools")
        let activeGlass = null // Track the currently active magnifier glass
        if (tools) {
            initializeSuperZoom()

            // Global event listeners for removing magnifier glass
            document.addEventListener("click", removeActiveGlassOnClickOutside)
            document.addEventListener("keydown", removeActiveGlassOnEscape)
        }

        function initializeSuperZoom() {
            document.querySelectorAll(".wp-block-image").forEach((imageContainer) => {
                if (!imageContainer.querySelector("a")) {
                    const superZoomDiv = document.createElement("div")
                    superZoomDiv.className = "superZoom"
                    imageContainer.appendChild(superZoomDiv)

                    imageContainer.querySelector("img").addEventListener("click", function (event) {
                        event.stopPropagation()

                        // Remove any existing magnifier glass
                        removeActiveGlass()

                        const cursorPos = {x: event.offsetX, y: event.offsetY}
                        activeGlass = magnify(event.target, 2, cursorPos)
                    })

                    superZoomDiv.addEventListener("click", () => openModal(imageContainer))
                } else {
                    return
                }
            })
        }

        function openModal(imageContainer) {
            const modal = document.createElement("div")
            modal.id = "myModal"
            modal.className = "modal"

            const closeBtn = document.createElement("span")
            closeBtn.className = "close"
            closeBtn.innerHTML = "&times;"

            const modalImg = document.createElement("img")
            modalImg.className = "modal-content"
            modalImg.src = imageContainer.querySelector("img").src

            const caption = document.createElement("div")
            caption.id = "caption"
            caption.innerText = imageContainer.querySelector("img").alt

            modal.append(closeBtn, modalImg, caption)
            document.querySelector(".text-tutorial-wrapper.tools").appendChild(modal)
            modal.style.display = "flex"

            closeBtn.onclick = () => modal.remove()
            caption.onclick = () => modal.remove()
            window.addEventListener("keydown", (event) => {
                if (event.key === "Escape") modal.remove()
            })
            modal.onclick = (e) => {
                if (e.target === modal) modal.remove()
            }
        }

        function magnify(img, zoom, cursorPos) {
            const glass = document.createElement("DIV")
            glass.setAttribute("class", "img-magnifier-glass")
            img.parentElement.insertBefore(glass, img)

            glass.style.backgroundImage = `url('${img.src}')`
            glass.style.backgroundRepeat = "no-repeat"
            glass.style.backgroundSize = `${img.width * zoom}px ${img.height * zoom}px`
            const bw = 3
            const w = glass.offsetWidth / 2
            const h = glass.offsetHeight / 2

            moveMagnifier({x: cursorPos.x, y: cursorPos.y})

            // Event listeners for moving magnifier
            const moveHandler = (e) => moveMagnifier(getCursorPos(e))
            glass.addEventListener("mousemove", moveHandler)
            img.addEventListener("mousemove", moveHandler)
            glass.addEventListener("touchmove", moveHandler)
            img.addEventListener("touchmove", moveHandler)

            // Remove magnifier glass on mouseleave or click
            glass.addEventListener("mouseleave", removeActiveGlass)
            glass.addEventListener("click", removeActiveGlass)

            function moveMagnifier(pos) {
                let x = pos.x
                let y = pos.y

                // Prevent magnifier glass from being positioned outside the image
                if (x > img.width - w / zoom) x = img.width - w / zoom
                if (x < w / zoom) x = w / zoom
                if (y > img.height - h / zoom) y = img.height - h / zoom
                if (y < h / zoom) y = h / zoom

                glass.style.left = `${x - w}px`
                glass.style.top = `${y - h}px`
                glass.style.backgroundPosition = `-${x * zoom - w + bw}px -${y * zoom - h + bw}px`
            }

            function getCursorPos(e) {
                const rect = img.getBoundingClientRect()
                return {
                    x: e.pageX - rect.left - window.pageXOffset,
                    y: e.pageY - rect.top - window.pageYOffset
                }
            }

            return glass
        }

        // Helper function to remove the active magnifier glass
        function removeActiveGlass() {
            if (activeGlass) {
                activeGlass.remove()
                activeGlass = null
            }
        }

        // Remove magnifier glass when clicking outside the image
        function removeActiveGlassOnClickOutside(event) {
            if (activeGlass && !event.target.closest(".wp-block-image")) {
                removeActiveGlass()
            }
        }

        // Remove magnifier glass when pressing the Escape key
        function removeActiveGlassOnEscape(event) {
            if (event.key === "Escape" && activeGlass) {
                removeActiveGlass()
            }
        }
    }, 1000) // Leave the 300ms delay as requested
}
